import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import {
  FButton,
  FCard,
  FGrid,
  FGridItem,
  FItem,
  FSelect,
  FTooltip,
  FTypo,
} from "ferrum-design-system";
import { ReactComponent as IconGoBack } from "../../../../../assets/img/icon-back-white.svg";
// import { ReactComponent as IconNetworkCFrm } from "../../../../../assets/img/icon-network-cfrm.svg";
// import { ReactComponent as IconNetworkBsc } from "../../../../../assets/img/icon-network-bnb.svg";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../redux/rootReducer";
import { PATH_DASHBOARD } from "../../../../../routes/paths";
import {
  getHumanReadableFarmName,
  getRemappedHumanReadableFarmName,
  getLatestStepToRender,
  getObjectReadableFarmName,
  // getNextStepFlowStepId,
} from "../../../common/Helper";
import {
  Crucible_Farm_Address_Details,
  getBaseTokenName,
  getCrucibleTokenName,
  STEP_FLOW_IDS,
} from "../../../common/utils";

import { ReactComponent as IconNetworkFrm } from "../../../../../assets/img/icon-network-frm.svg";
import IconNetworkCFrmStr from "../../../../../assets/img/icon-network-cfrm.svg";
import IconNetworkCFrmxStr from "../../../../../assets/img/icon-network-cfrmx.svg";
import { ReactComponent as IconNetworkBnb } from "../../../../../assets/img/icon-network-bnb.svg";
import { ClipLoader } from "react-spinners";
import {
  TokenSymbolIndex,
  networkLogoMap,
  tokenSymbols,
} from "../../../../../utils/constants";
import { createGlobalStyle, ThemeProvider } from "styled-components";

export const CrucibleManage = ({
  dashboardAction,
  setDashboardAction,
  setFlowType,
  unwrap,
  setUnwrap,
}: any) => {
  const history = useHistory();
  const location: any = useLocation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedToken, setSelectedToken] = useState<any>();
  const tokenPrices = useSelector(
    (state: RootState) => state.crucible.tokenPrices
  );
  const { theme, content } = useSelector((state: RootState) => state.config);
  // const { isConnected } = useSelector(
  //   (state: RootState) => state.walletConnector
  // );
  const { tokenV2 } = useSelector(
    (state: RootState) => state.walletAuthenticator
  );
  const { currentStep, currentStepIndex, stepFlowStepHistory } = useSelector(
    (state: RootState) => state.crucible
  );

  let { farm } = useParams<{ farm?: string }>();
  farm = farm === "cFRM-ARBITRUM" ? "cTestFrm" : farm;

  useEffect(() => {
    if (location.state === undefined) {
      history.push({ pathname: PATH_DASHBOARD.crucible.index });
    }
    // eslint-disable-next-line
  }, [location]);

  const onMintcFRMClick = () => {
    setIsLoading(true);
    let nextStepInfo: any =
      STEP_FLOW_IDS[`${getObjectReadableFarmName(farm)}`]?.mint;
    // console.log("next step id:", nextStepInfo);
    location.state.id = nextStepInfo.id;
    location.state.stepFlowName = nextStepInfo.name;
    // console.log(nextStepInfo, location.state);
    getLatestStepToRender(
      location.state,
      tokenV2,
      currentStep,
      currentStepIndex,
      stepFlowStepHistory,
      dispatch,
      history,
      farm,
      setIsLoading
    );
    // history.push({pathname:PATH_DASHBOARD.crucible.cFRM_BNB.mint.mint});
  };

  const onMintAndStakecFRMClick = () => {
    setIsLoading(true);
    let nextStepInfo: any =
      STEP_FLOW_IDS[`${getObjectReadableFarmName(farm)}`]?.mintAndStake;
    // console.log("next step id:", nextStepInfo);
    location.state.id = nextStepInfo?.id;
    location.state.stepFlowName = nextStepInfo?.name;
    getLatestStepToRender(
      location.state,
      tokenV2,
      currentStep,
      currentStepIndex,
      stepFlowStepHistory,
      dispatch,
      history,
      farm,
      setIsLoading
    );
    // history.push({pathname:PATH_DASHBOARD.crucible.cFRM_BNB.mint.mint});
  };

  const onWrapClick = () => {
    setIsLoading(true);
    let nextStepInfo: any =
      STEP_FLOW_IDS[`${getObjectReadableFarmName(farm)}`].unwrap;
    // console.log(nextStepInfo, location.state);
    location.state.id = nextStepInfo.id;
    location.state.stepFlowName = nextStepInfo.name;
    getLatestStepToRender(
      location.state,
      tokenV2,
      currentStep,
      currentStepIndex,
      stepFlowStepHistory,
      dispatch,
      history,
      farm,
      setIsLoading
    );
  };

  const handleSelectedToken = (option: any) => {
    window.open(option.url);
    setSelectedToken(option);
  };

  let selectTokens = [
    {
      value: "frm",
      label: (
        <FItem display={"flex"} alignY="center">
          <span className="icon-wrap">
            <span className="card-sell-images icon-network f-pr--5 flex">
              <img
                src={networkLogoMap["BSC"]}
                height="24px"
                width="24px"
                style={{ marginRight: "3px" }}
                alt=""
              />
              <IconNetworkFrm />
            </span>
          </span>{" "}
          <span>FRM</span>
        </FItem>
      ),
      network: "36",
      url: "https://pancakeswap.finance/swap?inputCurrency=BNB&outputCurrency=0xA719b8aB7EA7AF0DDb4358719a34631bb79d15Dc&exactField=output&exactAmount=0",
    },
    {
      value: "cfrm",
      label: (
        <FItem display={"flex"} alignY="center">
          <span className="card-sell-images icon-network f-pr--5 flex">
            <img
              src={networkLogoMap["BSC"]}
              height="24px"
              width="24px"
              style={{ marginRight: "3px" }}
              alt=""
            />
            <img src={IconNetworkCFrmStr} alt="network-cfrm" />
          </span>
          <span>cFRM</span>
        </FItem>
      ),
      url: "https://pancakeswap.finance/swap?inputCurrency=0xa719b8ab7ea7af0ddb4358719a34631bb79d15dc&outputCurrency=0xaf329a957653675613d0d98f49fc93326aeb36fc&exactField=output&exactAmount=",
    },
    {
      value: "cFRM",
      label: (
        <FItem display={"flex"} alignY="center">
          <span className="card-sell-images icon-network f-pr--5 flex">
            <img
              src={networkLogoMap["ARBITRUM"]}
              height="24px"
              width="24px"
              style={{ marginRight: "3px" }}
              alt=""
            />
            <img src={IconNetworkCFrmStr} height="22px" width="22px" />
          </span>
          <span>cFRM</span>
        </FItem>
      ),
      network: "42161",
      url: "https://app.sushi.com/swap?inputCurrency=0x9f6AbbF0Ba6B5bfa27f4deb6597CC6Ec20573FDA&outputCurrency=0xe685d3CC0be48BD59082eDe30C3b64CbFc0326e2&chainId=42161",
    },
    {
      value: "FRM",
      label: (
        <FItem display={"flex"} alignY="center">
          <span className="card-sell-images icon-network f-pr--5 flex">
            <img
              src={networkLogoMap["ARBITRUM"]}
              height="24px"
              width="24px"
              style={{ marginRight: "3px" }}
              alt=""
            />
            <IconNetworkFrm />
          </span>
          <span>FRM</span>
        </FItem>
      ),
      network: "42161",
      url: "https://app.sushi.com/swap?inputCurrency=ETH&outputCurrency=0x9f6AbbF0Ba6B5bfa27f4deb6597CC6Ec20573FDA&chainId=42161",
    },
  ];

  const currencyByCabn = theme?.crucibleConfig?.baseCurrency?.cabn || "";
  let crucibleTokens: { [key: string]: string }[] = [];
  if (currencyByCabn) {
    crucibleTokens = [
      {
        url: theme?.crucibleConfig?.baseCurrency?.dexLink,
        value: currencyByCabn?.currency?.symbol,
        network: (theme?.crucibleConfig?.crucibleFarms || [])[0]?.network,
      },
    ];
  }

  if (
    theme?.crucibleConfig?.crucibleFarms.length > 0 &&
    !theme?.crucibleConfig?.isDashboardEnabled
  ) {
    crucibleTokens.push({
      url: (theme?.crucibleConfig?.crucibleFarms || [])[0]?.crucibleDexLink,
      value: (theme?.crucibleConfig?.crucibleFarms || [])[0]
        ?.sustainableCrucibleFarms,
      network: (theme?.crucibleConfig?.crucibleFarms || [])[0]?.network,
    });
  }

  if (crucibleTokens.length > 0) {
    selectTokens = crucibleTokens.map((e) => {
      const buyLink = e.url.match(/^https?:/) ? e.url : "//" + e.url;
      return {
        value: e.value,
        label: (
          <FItem display={"flex"} alignY="center">
            <span className="card-sell-images icon-network f-pr--5 flex">
              <img
                src={networkLogoMap[e.network]}
                height="24px"
                width="24px"
                style={{ marginRight: "3px" }}
                alt=""
              />
              {tokenSymbols[e.value as TokenSymbolIndex] ? (
                <img
                  src={tokenSymbols[e.value as TokenSymbolIndex]}
                  height="24px"
                  width="24px"
                  style={{ marginRight: "3px" }}
                  alt=""
                />
              ) : (
                <IconNetworkFrm />
              )}
            </span>
            <span>{e.value}</span>
          </FItem>
        ),
        network: "42161",
        url: buyLink,
      };
    });
  }

  const GlobalStyles = createGlobalStyle`
  .crucible-farm-dashboard-card {
    background-image: url(${theme?.cards?.crucibleDashboardCard}) !important;
    .f-grid {
      .f-grid-item {
        .f-item {
          border: 1px solid ${theme?.colors?.neutralLight} !important;
          width: 100%;
        }
      }
    }
      .f-select__value-container{
        background: ${theme?.colors?.backgroundDark}!important;
      }
      .css-1hb7zxy-IndicatorsContainer {
        background: ${theme?.colors?.backgroundDark} !important;
      }
      .css-1wy0on6 {
        background: ${theme?.colors?.backgroundDark} !important;
      }
      .unwrap{
        background:${theme?.colors?.backgroundDark}!important;
        color:${theme?.colors?.primary}!important;
        border:1px solid ${theme?.colors?.primary}!important;
      }
      .f-select__placeholder{
        color:${theme?.colors?.primary}!important;
      }
      .css-tj5bde-Svg{
        color:${theme?.colors?.primaryLight}!important;
      }
      .css-13cymwt-control {
        border:1px solid ${theme?.colors?.primary}!important;
      }
      .mint-btn{
        outline:1px solid ${theme?.colors?.primary}!important;
        background:${theme?.colors?.primary}!important;
        border:1px solid ${theme?.colors?.primary}!important;
        color:${theme?.colors?.backgroundDark}!important;
      }
      .f-input-wrap{
        border:${theme?.colors?.primary}!important;
      }
    
    }
    .card-manage{ 
      .btn-wrap{ 
        .f-input-group{ 
          .f-input-wrap{ 
            .f-select{ 
              width:100%!important;
              .f-select__menu{ 
                .f-select__menu-list{
                  background:${theme?.colors?.background}!important;
                  color:${theme?.colors?.primaryLight}!important;
                  border:1px solid${theme?.colors?.primary}!important;
                  .f-select__option.f-select__option--is-focused, .card-manage .btn-wrap .f-input-group .f-input-wrap .f-select .f-select__menu .f-select__menu-list .f-select__option.f-select__option--is-selected{
                    background:${theme?.colors?.primary}!important;
                    border-color: ${theme?.colors?.red} !important;
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  const crucibleWlConfig = theme?.crucibleConfig;

  return (
    <>
      <ThemeProvider theme={theme}>
        {isLoading ? (
          // <FCard>
          <FItem align={"center"}>
            <ClipLoader
              color={theme?.colors?.primary}
              loading={true}
              size={150}
            />
          </FItem>
        ) : (
          // </FCard>
          <div className={"crucible-farm-dashboard-card"}>
            <div className="card-title f-mb-2">
              <FItem display={"flex"} alignY="center">
                <Link
                  to="/dashboard/crucible"
                  className="btn-back custom-mr-14"
                >
                  <IconGoBack />
                </Link>
                <FTypo
                  size={24}
                  weight={700}
                  color={theme?.colors?.primaryLight}
                >
                  {location?.state?.json[0]?.farmCard?.header ||
                    content?.farmDashboard?.farmCard?.header}{" "}
                  -{" "}
                  {crucibleWlConfig?.crucibleFarms[0]
                    ?.sustainableCrucibleFarms ||
                    getRemappedHumanReadableFarmName(farm)}
                </FTypo>
                <div className="flex-center-aligned-center">
                  <span
                    className="icon-wrap"
                    style={{ marginRight: 12, marginLeft: 24 }}
                  >
                    <img
                      src={
                        crucibleWlConfig?.crucibleFarms[0]
                          ?.sustainableCrucibleFarms === "cFRMx" ||
                        farm?.includes("cFRMx")
                          ? IconNetworkCFrmxStr
                          : crucibleWlConfig?.crucibleFarms[0]
                              .sustainableCrucibleFarms === "cFRM" ||
                            farm?.includes("cFRM")
                          ? IconNetworkCFrmStr
                          : crucibleWlConfig?.crucibleFarms[0]
                              .sustainableCrucibleFarms === "cLEO" ||
                            farm?.includes("cLEO")
                          ? tokenSymbols["cLEO"]
                          : IconNetworkCFrmxStr
                      }
                      height={22}
                      width={22}
                      alt="network-cfrm"
                    />
                    {farm?.includes("BNB") && <IconNetworkBnb />}
                  </span>
                  <FTypo
                    size={24}
                    weight={700}
                    color={theme?.colors?.primaryLight}
                  >
                    {crucibleWlConfig?.crucibleFarms[0]
                      ?.sustainableCrucibleFarms ||
                      getRemappedHumanReadableFarmName(farm)}
                  </FTypo>
                </div>
              </FItem>
              {/* <div className="network-icon-wrapper">
              <span className="icon-wrap">
                <img src={farm?.includes("cFRMx") ? IconNetworkCFrmxStr : IconNetworkCFrmStr} alt="network-cfrm" />
                {farm?.includes("BNB") && <IconNetworkBnb />}
              </span>
            </div> */}
            </div>
            {theme?.type === "ferrum" ? (
              <FGrid>
                <FGridItem size={[6, 6, 6]}>
                  <FItem
                    bgColor={theme?.colors?.background}
                    className={"f-p-2 "}
                  >
                    <FTypo
                      size={18}
                      color={theme?.colors?.backgroundLight}
                      className="f-mb-1 "
                    >
                      {getBaseTokenName(farm)} Price (USD)
                    </FTypo>
                    <FTypo
                      size={30}
                      weight={500}
                      color={theme?.colors?.primaryLight}
                    >
                      ${tokenPrices[getBaseTokenName(farm)!] || 0}
                    </FTypo>
                  </FItem>
                </FGridItem>
                <FGridItem size={[6, 6, 6]}>
                  <FItem
                    bgColor={theme?.colors?.background}
                    className={"f-p-2 "}
                  >
                    <FTypo
                      size={18}
                      color={theme?.colors?.backgroundLight}
                      className="f-mb-1 "
                    >
                      {getCrucibleTokenName(farm)} Price (USD)
                    </FTypo>
                    <FTypo
                      size={30}
                      weight={500}
                      color={theme?.colors?.primaryLight}
                    >
                      ${tokenPrices[getCrucibleTokenName(farm)!] || 0}
                    </FTypo>
                  </FItem>
                </FGridItem>
              </FGrid>
            ) : null}
            <FGrid className="btn-wrap f-mt-1 f-mb-2" spacing={5}>
              <FGridItem size={[3, 3, 3]}>
                {/* <div> */}
                <FSelect
                  name={"selectOptions"}
                  placeholder="BUY TOKEN"
                  options={selectTokens}
                  className="buy-token-select"
                  value={selectedToken}
                  onChange={(option: any) => handleSelectedToken(option)}
                />
                {/* </div> */}
              </FGridItem>
              <FGridItem size={[2, 2, 2]}>
                {(crucibleWlConfig?.crucibleFlowType == "default" ||
                  !crucibleWlConfig?.crucibleFlowType) && (
                  <div className={"w-100"}>
                    <FButton
                      title={
                        farm?.includes("cFRM-")
                          ? "MINT cFRM"
                          : farm?.includes("cFRMx-")
                          ? "MINT cFRMx"
                          : "MINT"
                      }
                      style={{ width: "100%" }}
                      className={
                        "f-btn-gradiant clr_new_black custom-font-size-16 font-700 stake-btn"
                      }
                      onClick={() => onMintcFRMClick()}
                    ></FButton>
                  </div>
                )}
              </FGridItem>

              {!crucibleWlConfig?.isCustomClaimEnabled && (
                <FGridItem size={[3, 3, 3]}>
                  <div className={"f-pl-1 w-100"}>
                    <FButton
                      variant={"secondary"}
                      title={"UNWRAP"}
                      outlined
                      className={
                        "custom-mr-16 custom-font-size-16 font-700 unwrap "
                      }
                      style={{
                        width: 114,
                        borderColor: "#D9B373",
                        borderRadius: 8,
                      }}
                      onClick={() => onWrapClick()}
                    />
                  </div>
                </FGridItem>
              )}
              <FGridItem size={[4, 4, 4]}>
                <div className={"w-100"}>
                  {(crucibleWlConfig?.crucibleFlowType == "default" ||
                    !crucibleWlConfig?.crucibleFlowType) && (
                    <FButton
                      title={
                        farm?.includes("cFRM-")
                          ? "Mint and stake cFRM"
                          : farm?.includes("cFRMx-")
                          ? "Mint and stake cFRMx"
                          : "Mint and stake"
                      }
                      className={"w-100 stake-btn clr_new_black"}
                      onClick={() => onMintAndStakecFRMClick()}
                    ></FButton>
                  )}
                  {(crucibleWlConfig?.crucibleFlowType === "stakeOnly" ||
                    crucibleWlConfig?.crucibleFlowType ===
                      "mintWithMintAndStake") && (
                    <>
                      <FButton
                        title={
                          farm?.includes("cFRM-") ? (
                            "Mint and stake cFRM"
                          ) : farm?.includes("cFRMx-") ? (
                            "Mint and stake cFRMx"
                          ) : crucibleWlConfig?.crucibleFlowType
                              ?.crucibleFlowTypeTooltipMessage ? (
                            <FTooltip
                              className={"p-0 f-mt-0 f-mb-0"}
                              effect={"solid"}
                              place={"top"}
                              id="TooltipTop"
                              textColor={"white"}
                              backgroundColor={"black"}
                              text={"WRAP AND STAKE"}
                            >
                              {crucibleWlConfig?.crucibleFlowType
                                ?.crucibleFlowTypeTooltipMessage || ""}
                            </FTooltip>
                          ) : (
                            "WRAP AND STAKE"
                          )
                        }
                        className={
                          "clr_new_black custom-font-size-16 font-700 stake-btn "
                        }
                        style={{ width: 266 }}
                        onClick={() => onMintAndStakecFRMClick()}
                      ></FButton>
                    </>
                  )}
                </div>
              </FGridItem>
            </FGrid>
          </div>
          // <FCard variant={"secondary"} className="card-manage-crucible card-shadow">
          // <div className="card-title f-mb-2">
          //   <FItem display={"flex"} alignY="center">
          //     <Link to="/dashboard/crucible" className="btn-back">
          //       <IconGoBack />
          //     </Link>
          //     <FTypo size={24} weight={700}>
          //       Crucible Farms Dashboard - {getHumanReadableFarmName(farm)}
          //     </FTypo>
          //   </FItem>
          //   <div className="network-icon-wrapper">
          //     <span className="icon-wrap">
          //       <img src={farm?.includes("cFRMx") ? IconNetworkCFrmxStr : IconNetworkCFrmStr} alt="network-cfrm" />
          //       {farm?.includes("BNB") && <IconNetworkBnb />}
          //     </span>
          //   </div>
          // </div>
          // <FGrid>
          //   <FGridItem size={[6, 6, 6]}>
          //     <FItem bgColor="#1C2229" className={"f-p-2"}>
          //       <FTypo size={20} className="f-mb-1">
          //         {getBaseTokenName(farm)} Price (USD)
          //       </FTypo>
          //       <FTypo size={30} weight={500}>
          //         ${tokenPrices[getBaseTokenName(farm)!] || 0}
          //       </FTypo>
          //     </FItem>
          //   </FGridItem>
          //   <FGridItem size={[6, 6, 6]}>
          //     <FItem bgColor="#1C2229" className={"f-p-2"}>
          //       <FTypo size={20} className="f-mb-1">
          //         {getCrucibleTokenName(farm)} Price (USD)
          //       </FTypo>
          //       <FTypo size={30} weight={500}>
          //         ${tokenPrices[getCrucibleTokenName(farm)!] || 0}
          //       </FTypo>
          //     </FItem>
          //   </FGridItem>
          // </FGrid>
          // <FGrid className="btn-wrap f-mt-1" spacing={5}>
          //   <FGridItem size={[4, 4, 4]}>
          //     <FSelect
          //       name={"selectOptions"}
          //       placeholder="Buy Token"
          //       options={selectTokens}
          //       value={selectedToken}
          //       onChange={(option: any) => handleSelectedToken(option)}
          //     />
          //   </FGridItem>

          //   <FGridItem size={[4, 4, 4]}>
          //     <FButton
          //       title={farm?.includes("cFRM-") ? "Mint cFRM" : farm?.includes("cFRMx-") ? "Mint cFRMx" : "Mint"}
          //       className={"w-100 f-btn-gradiant"}
          //       onClick={() => onMintcFRMClick()}></FButton>
          //   </FGridItem>
          //   <FGridItem size={[4, 4, 4]}>
          //     <FButton variant={"secondary"} title={"Unwrap"} outlined className={"w-100"} onClick={() => onWrapClick()}></FButton>
          //   </FGridItem>
          // </FGrid>
          // </FCard>
        )}

        <GlobalStyles />
      </ThemeProvider>
    </>
  );
};
